var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormMaterials.jinja');
require('./SubmissionFormMaterials.less');
var CommonStory = require('front/components/CommonStory/CommonStory');

var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {

    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonStory': {selector: '.CommonStory', viewConstructor: CommonStory}
    },


    initialize: function (options) {
        this.options = options || {};

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    checkRequired: function () {
        return true;
    },


    getFormData: function () {
        return {};
    }
});





//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormMaterials.js
// module id = 119
// module chunks = 0